
import EmvDataFormHandler from '@Modules/admin/archiving/containers/formHandlers/consultationAuthorizationsDetails/emvData/EmvDataFormHandler'
import { useParams } from 'react-router-dom';

const EMVDataPage = () => {
  const {id} = useParams();
  const oneId = id || 0;
  
  return (
    <EmvDataFormHandler id={oneId} />
  )
}

export default EMVDataPage